import CryptoJS from 'crypto-js';

const sk = "oIYS26RdTLX9sxG";

const EncryptData = async (data) => {
  let options = {
    data,
    sk: "0czjbkOh87RTYGpg6ObWtqnmgG6mro2m"
  }

  let ciphertext = await CryptoJS.AES.encrypt(JSON.stringify(options.data), options.sk);
  let RANDOM_PID = Math.floor((Math.random() * 1000));
  let RDKEY = btoa("U2FsdGVkX1+ktoJql62zygpFkGyXUq9KtS+jguYPNbX7UDq0fwTGdwMd9BVy7MoVFPfkO9vAt9FzeFw2Lsb02Q==");

  let dataOptions = {
    _pid: RANDOM_PID,
    _edv: RDKEY,
    _mt: RDKEY.length * RANDOM_PID / 2,
    ed: ciphertext.toString()
  }

  return dataOptions;
}

export const simpleCrypt = data => {
  let options = {
    data,
    sk
  }

  let ciphertext = CryptoJS.AES.encrypt(options.data, options.sk)
  return ciphertext.toString()
}

export const SimpleDecrypt = data => {
  let options = {
    data,
    sk
  }

  let bytes = CryptoJS.AES.decrypt(options.data, options.sk)
  let text = bytes.toString(CryptoJS.enc.Utf8)

  return text
}

export { EncryptData as EncryptMe }